import { Component, inject, signal, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { Capacitor } from '@capacitor/core';
import { PwaService } from '../../services/pwa.service';
import { TranslatePipe } from '../../../pipes/translate.pipe';

const DISMISS_KEY = 'pwa_install_banner_dismissed';

@Component({
  selector: 'app-pwa-install-banner',
  standalone: true,
  imports: [CommonModule, MatIcon, TranslatePipe],
  templateUrl: './pwa-install-banner.component.html',
  styleUrl: './pwa-install-banner.component.scss',
})
export class PwaInstallBannerComponent implements OnInit {
  private readonly pwaService = inject(PwaService);

  readonly showBanner = signal(false);
  readonly showIosInstructions = signal(false);
  readonly isIos = signal(false);

  ngOnInit(): void {
    if (Capacitor.isNativePlatform()) {
      return;
    }

    const dismissed = localStorage.getItem(DISMISS_KEY);
    if (dismissed) {
      return;
    }

    this.isIos.set(this.pwaService.platform() === 'ios');

    if (this.pwaService.showInstallButton()) {
      this.showBanner.set(true);
    }
  }

  install(): void {
    if (this.isIos()) {
      this.showIosInstructions.set(true);
    } else {
      this.pwaService.installPwa();
    }
  }

  dismiss(): void {
    localStorage.setItem(DISMISS_KEY, 'true');
    this.showBanner.set(false);
  }

  closeInstructions(): void {
    this.showIosInstructions.set(false);
  }
}
